import type { TransportEvent, TransportHandler } from '../types';

/**
 * Pub/sub abstraction over whatever real-time transport is active.
 * Multiple topics are supported so that future features (chat, game-events, presence)
 * can subscribe through the same wire when WS lands.
 */
export class NotificationBus {
  private handlers = new Map<string, Set<TransportHandler>>();

  subscribe(topic: string, handler: TransportHandler): () => void {
    let set = this.handlers.get(topic);
    if (!set) {
      set = new Set();
      this.handlers.set(topic, set);
    }
    set.add(handler);
    return () => set!.delete(handler);
  }

  emit(topic: string, event: TransportEvent): void {
    const set = this.handlers.get(topic);
    if (!set) return;
    for (const h of set) {
      try {
        h(event);
      } catch (e) {
        // Never let one handler take down the bus.
        console.error('[NotificationBus] handler threw:', e);
      }
    }
  }
}
